import { productPopupAtoms } from "./headerHooks";
import usePopup from "./usePopup";

const useProductPopup = () => {
  const popup = usePopup(productPopupAtoms);
  return popup;
};

export default useProductPopup;
